// Pinia store: localApi (migration from Vuex module)
import { defineStore } from 'pinia'
import CryptoJS from 'crypto-js'
import AesUtil from '../helpers/aesUtil.js'
import clientServices from '../clientServices.js'

function determineMinPasswordLength () {
  return 12
}

function determinePasswordRules () {
  const ruleLines = []
  const minPasswordLength = determineMinPasswordLength()
  ruleLines[0] = 'Password must be at least ' + minPasswordLength + ' characters long.'
  ruleLines[1] = 'Password must not contain first or last names.'
  ruleLines[2] = 'Password must not contain username.'
  ruleLines[3] = 'Password must have two alphabetic characters.'
  ruleLines[4] = 'Password must have one numeric character.'
  ruleLines[5] = 'Password must have one lowercase letter.'
  ruleLines[6] = 'Password must have one uppercase letter.'
  return ruleLines
}

export const useLocalApiStore = defineStore('localApi', {
  state: () => ({
    sessionKey: ''
  }),
  getters: {
    getSessionKey: (state) => state.sessionKey
  },
  actions: {
    setSessionKey (sessionKeyIn) { this.sessionKey = sessionKeyIn },
    async newSessionKey () {
      const sessionKey = await clientServices.getSessionKey()
      this.sessionKey = sessionKey
      return sessionKey
    },
    encryptPassword ({ sessionKey, password }) {
      const aesUtil = new AesUtil(128, 1000)
      const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex)
      const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex)
      const newCipherText = aesUtil.encrypt(salt, iv, sessionKey, password)
      const newAesPassword = (iv + '::' + salt + '::' + newCipherText)
      const encPassword = btoa(newAesPassword)
      return btoa(encPassword)
    },
    getPasswordRules () { return determinePasswordRules() },
    validateDate (localDate) {
      localDate = localDate.replace(/\D/g, '')
      if (localDate.substring(4, 5) === '-') {
        localDate = localDate.substring(5, 7) + localDate.substring(8, 10) + localDate.substring(0, 4)
      }
      if (localDate.length === 8) {
        try {
          const date = new Date(localDate.substring(0, 2) + '/' + localDate.substring(2, 4) + '/' + localDate.substring(4, 8))
          return (date instanceof Date && !isNaN(date.valueOf()))
        } catch (err) {
          return false
        }
      } else {
        return false
      }
    },
    validatePasswordRules ({ password, confirmPassword }) {
      const minPasswordLength = determineMinPasswordLength()
      const ruleLines = determinePasswordRules()
      let rules = ''
      for (let i = 0; i < ruleLines.length; i++) {
        rules = rules + ruleLines[i] + '\n'
      }

      let matching = false
      if (password === confirmPassword) matching = true

      let oneNumeric = false
      let oneUpperCase = false
      let oneLowerCase = false
      let twoAlpha = 0

      let i = 0
      while (i <= password.length - 1) {
        const character = password.charAt(i)
        if (/[0-9]/.test(character)) oneNumeric = true
        if (/[A-Z]/.test(character)) oneUpperCase = true
        if (/[a-z]/.test(character)) oneLowerCase = true
        if (/[a-zA-Z]/.test(character)) twoAlpha = twoAlpha + 1
        i++
      }

      if (password.length >= minPasswordLength && oneNumeric && oneUpperCase && oneLowerCase && twoAlpha >= 2 && matching) {
        return { status: true, message: null }
      } else {
        let errorMessage
        if (matching === false) {
          errorMessage = 'Passwords entered do not match. Please try again.'
        } else if (password.length < minPasswordLength || twoAlpha < 2 || oneNumeric === false || oneUpperCase === false || oneLowerCase === false) {
          errorMessage = 'Password entered does not meet criteria. Please Try again.'
        } else {
          errorMessage = 'General Validation Failure. Please Try again.\n\nIf you continue to receive this message, please contact Login support at the link below.'
        }
        return { status: false, message: errorMessage }
      }
    },
    getNotification () { return clientServices.getNotification() },
    getLinkLists () { return clientServices.getLinkList() },
    resetPassword (data) { return clientServices.resetPassword(data) },
    validateAccount (data) { return clientServices.validateAccount(data.params) },
    getAccountData (data) { return clientServices.getAccountData(data.params) },
    accountLookup (data) { return clientServices.accountLookup(data) },
    updateContactData (data) { return clientServices.updateAccount(data.params) },
    checkCaptcha (data) { return clientServices.checkCaptcha(data) },
    async sendOtpCode (data) { return clientServices.sendOtpCode(data) },
    async checkOtpCode (data) { return clientServices.checkOtpCode(data) },
    async unlockAccount (data) { return clientServices.unlockAccount(data) }
  }
})
